import { useEffect } from 'react';
import {
  getAuth,
  onAuthStateChanged,
  signOut,
  browserLocalPersistence,
  setPersistence
} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'lastActivity';

export function useInactivityLogout(tempoInatividade = 30 * 60 * 1000) {
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    setPersistence(auth, browserLocalPersistence)
      .catch(err => console.warn('[inactivity] setPersistence falhou:', err));
  }, [auth]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const eventos = ['mousedown','mousemove','keypress','scroll','touchstart','click'];

    const doLogout = async () => {
      if (auth.currentUser) {
        await signOut(auth);
      }
      localStorage.removeItem(STORAGE_KEY);
      navigate('/signin');
    };

    const resetTimer = () => {
      clearTimeout(timer);
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
      timer = setTimeout(doLogout, tempoInatividade);
    };

    const clearAll = () => {
      clearTimeout(timer);
      eventos.forEach(e => document.removeEventListener(e, resetTimer));
    };

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      clearAll();

      if (user) {
        const last = Number(localStorage.getItem(STORAGE_KEY));

        if (last && (Date.now() - last > tempoInatividade)) {
          doLogout();
          return;
        }

        resetTimer();
        eventos.forEach(e => document.addEventListener(e, resetTimer));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    });

    return () => {
      unsubscribe();
      clearAll();
      localStorage.removeItem(STORAGE_KEY);
    };
  }, [auth, navigate, tempoInatividade]);
}
